// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"411c0e0f","513":"bf37b5bf"}[chunkId] + ".chunk.js";
};